// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__38YHP","header":"ReportDetails_header__3rCLF","title":"ReportDetails_title__1sXqu","left":"ReportDetails_left__261lS"};